import script from "./ViewUnlinkedPaymentVouchersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewUnlinkedPaymentVouchersPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewUnlinkedPaymentVouchersPage.vue?vue&type=style&index=0&id=2ce8ae0f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce8ae0f"]])

export default __exports__